/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol } from 'sarsaparilla';

export default class SnowmobileCounter extends PureComponent {
    static propTypes = {
        snowmobiles: PropTypes.number,
        handleSnowmobilesChange: PropTypes.func,
        maxSnowmobiles: PropTypes.number,
        showIsRequired: PropTypes.bool,
    };

    static defaultProps = {
        snowmobiles: 0,
        maxSnowmobiles: 99,
        handleSnowmobilesChange: () => {},
        showIsRequired: false,
    };

    onChange = (e) => {
        let { value } = e.target;
        value = Number.parseInt(value, 10);

        if (value >= 0 && value <= this.props.maxSnowmobiles) {
            this.props.handleSnowmobilesChange(value);
        }
    };

    render() {
        return (
            <div className="per-equipment-form per-section-group">
                <div className="rec-order-detail-subsection-title">Snowmobiles</div>
                <p>
                    Please enter the amount of snowmobiles you plan on using on this trip.
                    Maximum of {this.props.maxSnowmobiles} per group. Only 2 people per 1
                    snowmobile.
                </p>
                <p>All operators must be 16 and hold a valid drivers license.</p>
                <FlexRow>
                    <FlexCol md={3}>
                        <div className="rec-form-item-wrap">
                            <label htmlFor="snowmobileCountInput">Quantity</label>
                            <input
                                id="snowmobileCountInput"
                                className={this.props.showIsRequired ? 'rec-error' : ''}
                                type="number"
                                min="0"
                                max={this.props.maxSnowmobiles}
                                step="1"
                                value={this.props.snowmobiles}
                                onChange={this.onChange}
                            />
                        </div>
                    </FlexCol>
                </FlexRow>
            </div>
        );
    }
}
